import { z } from "zod";
import { getProjectSchema } from "../../project/api/get-project.schema";

export const getProjectResourceLinkSchema = z
	.object({
		resourceLinkId: z.uuid(),
	})
	.and(getProjectSchema);

export type GetProjectResourceLinkSchema = z.infer<typeof getProjectResourceLinkSchema>;
